/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedPeopleMultiple200,
  GetApiV1PersonSharedPeopleMultiple401,
  GetApiV1PersonSharedPeopleMultiple500,
  GetApiV1PersonSharedPeopleMultipleQueryParams,
  GetApiV1PersonSharedPeopleMultipleQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1PersonSharedPeopleMultiple.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";
import { ePersonTypeSchema } from "../ePersonTypeSchema.ts";

export const getApiV1PersonSharedPeopleMultipleQueryParamsSchema = z.object({
  filter: z.optional(z.string()),
  type: z.optional(
    z
      .lazy(() => ePersonTypeSchema)
      .describe(
        "1 = Employee | 2 = Teaching | 3 = Student | 4 = Monitor | 5 = Seller | 6 = Advisor | 7 = SellerManager | 8 = Coordinator | ",
      ),
  ),
  companyId: z.optional(z.coerce.number().int()),
  activeOnly: z.boolean().default(false),
}) as unknown as ToZod<GetApiV1PersonSharedPeopleMultipleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedPeopleMultiple200Schema = z.array(
  z.lazy(() => dropDownListStringKeyViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedPeopleMultiple200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedPeopleMultiple401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedPeopleMultiple401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedPeopleMultiple500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedPeopleMultiple500>;

export const getApiV1PersonSharedPeopleMultipleQueryResponseSchema = z.lazy(
  () => getApiV1PersonSharedPeopleMultiple200Schema,
) as unknown as ToZod<GetApiV1PersonSharedPeopleMultipleQueryResponse>;
